import React, { useEffect, useState, useCallback } from "react";
import { fetchImageUrl } from "../utility/service/api-file";
import { Image } from "primereact/image";
import { Button } from "primereact/button";

const ImgRender = ({ 
    imgPathSml, 
    alt = '', 
    placeholder = null, 
    imgRef,
    deleteImg,
    disabled,
    imgPathZoom,
    imgWidth,
    imgHeight,
    className = '' 
}) => {
    const [imgSrc, setImgSrc] = useState('');
    const [zoomSrc, setZoomSrc] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState(false);
    const [isZoomLoaded, setIsZoomLoaded] = useState(false);

    // 提取圖片 URL 的共用方法
    const extractImageUrl = useCallback(async (path) => {
        // 如果路徑為空，直接返回空字串
        if (!path) return '';

        try {
            if (typeof path === 'string' && path.includes('fileId')) {
                const fileIdMatch = path.match(/fileId[=:](\w+)/);
                if (fileIdMatch) {
                    return await fetchImageUrl({path});
                }
            }
            return path;
        } catch (error) {
            console.error('Image fetch error:', error);
            return '';
        }
    }, []);

    // 處理小圖加載
    useEffect(() => {
        // 如果 imgPathSml 為空，不執行返回
        if (!imgPathSml) {
            setImgSrc('');
            return;
        }

        const fetchImage = async () => {
            setIsLoading(true);
            setError(false);
            try {
                const url = await extractImageUrl(imgPathSml);
                setImgSrc(url);
                setIsLoading(false);
            } catch (error) {
                console.error('Image fetch error:', error);
                setError(true);
                setIsLoading(false);
            }
        };

        fetchImage();

        // 清除函數
        return () => {
            if (imgSrc && imgSrc.startsWith('blob:')) {
                URL.revokeObjectURL(imgSrc);
            }
        };
    }, [imgPathSml, extractImageUrl]);

    // 處理大圖載入
    const handleLoadZoomImage = useCallback(async () => {
        // 只有在未載入時才進行載入
        if (!isZoomLoaded && imgPathZoom) {
            try {
                const url = await extractImageUrl(imgPathZoom);
                setZoomSrc(url);
                setIsZoomLoaded(true);
            } catch (error) {
                console.error('Zoom image fetch error:', error);
            }
        }
    }, [imgPathZoom, isZoomLoaded, extractImageUrl]);

    // 渲染邏輯
    if (!imgPathSml) return null;
    if (isLoading) return placeholder || <div className="flex items-center justify-center h-full w-full"><i className="pi pi-spin pi-spinner"></i></div>;
    if (error) return <div>Image load error</div>;

    return imgSrc ? (
        <div
            className="custom-image-preview"
            style={{ "--height": `${imgHeight}px`, "--width": `${imgWidth}px` }}
        >
            <Image
                zoomSrc={zoomSrc}
                src={imgSrc}
                alt={alt}
                width={imgWidth}
                height={imgHeight}
                preview
                ref={imgRef}
                className={disabled ? "" : "original-preview-none"}
                onShow={handleLoadZoomImage}  // 只有在點擊預覽時才加載大圖
            />
            <div className="custom-image-edit-indicator">
                <Button
                    type="button"
                    icon="pi pi-eye"
                    className="p-button-icon-only"
                    rounded
                    text
                    onClick={() => imgRef.current?.show()}
                ></Button>

                {!disabled && (
                    <Button
                        type="button"
                        icon="pi pi-trash"
                        className="p-button-icon-only"
                        rounded
                        text
                        severity="danger"
                        onClick={deleteImg}
                    ></Button>
                )}
            </div>
        </div>
    ) : null;
};

export default ImgRender;